var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-main-nav",
      attrs: { role: "navigation" },
      on: {
        mouseleave: function($event) {
          return _vm.handleMouseLeave()
        }
      }
    },
    [
      _c("div", { staticClass: "o-width-limiter" }, [
        _c("span", { staticClass: "t-visually-hidden" }, [
          _vm._v("Huvudnavigering")
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "c-main-nav__list" },
          _vm._l(_vm.links, function(link, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "c-main-nav__item",
                class: { "c-main-nav__item--selected": link.selected },
                attrs: {
                  "aria-controls": "content-" + index,
                  "aria-expanded":
                    _vm.$resize &&
                    _vm.$mq.above(1025) &&
                    _vm.currentSubLevelIndex === index
                      ? true
                      : false
                },
                on: {
                  mouseover: function($event) {
                    return _vm.handleMouseOver(index)
                  },
                  keydown: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        $event.keyCode !== 32
                      ) {
                        return null
                      }
                      return _vm.triggerSpace($event, index)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        $event.keyCode !== 38
                      ) {
                        return null
                      }
                      return _vm.triggerKeyPress($event, index)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        $event.keyCode !== 40
                      ) {
                        return null
                      }
                      return _vm.triggerKeyPress($event, index)
                    }
                  ],
                  keyup: function($event) {
                    return _vm.triggerKeyPress($event, index)
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "c-main-nav__link",
                    attrs: { id: "item-" + index, href: link.url }
                  },
                  [
                    _c("v-icon", {
                      attrs: {
                        name: "icon-" + link.icon,
                        size: "m",
                        "css-modifiers": "c-main-nav__icon"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "c-main-nav__link-body" }, [
                      _c("span", { staticClass: "c-main-nav__title" }, [
                        _vm._v(_vm._s(link.name))
                      ]),
                      _vm._v(" "),
                      _c("small", { staticClass: "c-main-nav__label" }, [
                        _vm._v(_vm._s(link.subname))
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$resize && _vm.$mq.above(1025)
                  ? _c(
                      "div",
                      {
                        class:
                          _vm.currentSubLevelIndex === index
                            ? "c-main-nav__content c-main-nav__content--show"
                            : "c-main-nav__content",
                        attrs: {
                          id: "content-" + index,
                          "aria-expanded":
                            _vm.$resize &&
                            _vm.$mq.above(1025) &&
                            _vm.currentSubLevelIndex === index
                              ? true
                              : false,
                          "aria-hidden":
                            _vm.$resize &&
                            _vm.$mq.above(1025) &&
                            _vm.currentSubLevelIndex === index
                              ? false
                              : true,
                          "aria-labelledby": "item-" + index,
                          role: "group"
                        }
                      },
                      [
                        _c("div", { staticClass: "o-width-limiter" }, [
                          _c("span", { staticClass: "t-visually-hidden" }, [
                            _vm._v("Subnavigering")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "c-main-nav__content-wrapper" },
                            [
                              _c(
                                "div",
                                { staticClass: "c-main-nav__content-left" },
                                [
                                  _c(
                                    "ul",
                                    { staticClass: "c-main-nav__content-list" },
                                    _vm._l(link.pages, function(page, i) {
                                      return _c(
                                        "li",
                                        {
                                          key: i,
                                          staticClass:
                                            "c-main-nav__content-item",
                                          class: { selected: page.selected }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "c-main-nav__content-link",
                                              attrs: { href: page.url }
                                            },
                                            [
                                              _c("v-icon", {
                                                attrs: {
                                                  name: "icon-" + page.icon,
                                                  size: "m",
                                                  "css-modifiers":
                                                    "c-main-nav__icon"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-main-nav__link-body"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "c-main-nav__title"
                                                    },
                                                    [_vm._v(_vm._s(page.name))]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "c-main-nav__label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(page.subname)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  link.faq.position === "bottom"
                                    ? _c("v-main-nav-faq", {
                                        attrs: { faq: link.faq }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "c-main-nav__content-right" },
                                [
                                  link.contact
                                    ? _c("v-main-nav-contact", {
                                        attrs: { contact: link.contact }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  link.faq.position === "right"
                                    ? _c("v-main-nav-faq", {
                                        attrs: { faq: link.faq }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }